function once(elm, cb) {
  const standarTransitionEnd = window.webkitURL
    ? 'webkitTransitionEnd'
    : 'transitionend';
  $(elm).one(standarTransitionEnd, cb);
}

export default {
  once,
};
